import { TypographyV2 } from '@which/seatbelt'
import { ChevronRightIcon, CrossIcon } from '@which/seatbelt/src/components/Icons'
import { dynamicGa4DataLayerPush } from '@which/shared'

import { analytics } from '../Configs/analytics'
import type { Category } from '../Configs/categories'
import { ctas } from '../Configs/ctas'
import { useGuidedPurchaseItemSpec } from '../hooks/useGuidedPurchaseItemSpec'
import styles from './GuidedPurchaseJourneyButton.module.scss'

interface GuidedPurchaseJourneyButtonProps {
  onClick: () => void
  onDismiss: () => void
  categorySlug: Category
}

export const GuidedPurchaseJourneyButton = ({
  onClick,
  onDismiss,
  categorySlug,
}: GuidedPurchaseJourneyButtonProps) => {
  const { buttonText, launchButtonText, launchButtonDescription, imageUrl } = ctas[categorySlug]
  const itemSpec = useGuidedPurchaseItemSpec()

  const handleClick = () => {
    dynamicGa4DataLayerPush({
      event: 'personalisation_tool_action',
      action_group: 'action',
      item_text: buttonText,
      item_spec: itemSpec,
      item_group: 'personalisation tools',
      tool_name: analytics[categorySlug].tool_name,
      item_personalisation: 'false',
    })
    onClick()
  }

  return (
    <div className={styles.laptopHelperButton}>
      <button
        className={styles.launchButton}
        onClick={handleClick}
        type="button"
        aria-label={buttonText}
      >
        <div
          className={styles.desktopArtwork}
          aria-hidden="true"
          style={{ backgroundImage: `url(${imageUrl})` }}
        />
        <div className={styles.desktopCopy}>
          <TypographyV2 textStyle="sb-text-interface-body-default-strong">
            {launchButtonText}
          </TypographyV2>
          <TypographyV2 textStyle="sb-text-interface-body-small-regular">
            {launchButtonDescription}
          </TypographyV2>
        </div>
        <span className={styles.laptopHelperButtonText}>{buttonText}</span>
        <ChevronRightIcon className={styles.chevronIcon} />
      </button>
      <button
        className={styles.closeButton}
        type="button"
        aria-label="Dismiss laptop helper launcher"
        onClick={onDismiss}
      >
        <CrossIcon width={15} height={15} customColour="gray" />
      </button>
    </div>
  )
}
